import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { nextRoute } from "@/pages/Auth";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(token ? "" : "This reset link is missing its token.");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      setUser(data);
      toast.success("Password updated — you're signed in");
      nav(nextRoute(data), { replace: true });
    } catch (err) { setError(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen orbit-bg-grid flex items-center justify-center p-4" data-testid="reset-password-page">
      <div className="orbit-glass rounded-3xl p-8 max-w-sm w-full orbit-fade-up">
        <Link to="/" className="font-display text-xl font-extrabold tracking-tight">ORBIT<span className="orbit-gradient-text">HELLO</span></Link>
        <div className="w-12 h-12 mt-6 rounded-full bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center"><KeyRound className="w-5 h-5 text-cyan-300" /></div>
        <h1 className="font-display text-2xl font-bold mt-4">Choose a new password</h1>
        {error ? (
          <>
            <p className="text-rose-300 text-sm mt-3" data-testid="reset-error">{error}</p>
            <button onClick={() => nav("/auth")} className="orbit-btn-primary w-full mt-6" data-testid="reset-back-btn">Request a new link</button>
          </>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-4">
            <input required autoFocus type="password" minLength={6} placeholder="New password (6+ characters)" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-xl bg-slate-950/60 border border-white/10 focus:border-cyan-400 outline-none text-slate-100" data-testid="reset-password-input" />
            <input required type="password" minLength={6} placeholder="Repeat new password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="w-full px-4 py-3 rounded-xl bg-slate-950/60 border border-white/10 focus:border-cyan-400 outline-none text-slate-100" data-testid="reset-confirm-input" />
            <button type="submit" disabled={loading} className="orbit-btn-primary w-full" data-testid="reset-submit-btn">{loading ? "…" : "Save & sign in"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
